import { render, staticRenderFns } from "./footer-info.vue?vue&type=template&id=667ce7cd&"
import script from "./footer-info.vue?vue&type=script&lang=js&"
export * from "./footer-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports